import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBathMan1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBathMan1"><Circle cx="12" cy="4" r="2.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M15.25 22.25V16.25H16.25C16.8023 16.25 17.25 15.8023 17.25 15.25V11.75C17.25 10.0931 15.9069 8.75 14.25 8.75H9.75C8.09315 8.75 6.75 10.0931 6.75 11.75V15.25C6.75 15.8023 7.19772 16.25 7.75 16.25H8.75V22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBathMan1;
